/* ============================================================
 * pdp.js — Product Detail Page (商品詳細ページ)
 * 機能: 画像ギャラリー / アコーディオン / 閲覧履歴
 * Splide はテーマ内で既に gaming-pc-page で導入済の CDN を再利用
 * ============================================================ */
(function () {
  'use strict';

  // ---- Image Gallery (Splide) ----
  function initGallery() {
    var el = document.querySelector('.pdp-gallery__main.splide');
    if (!el || typeof Splide === 'undefined') return;

    var splide = new Splide(el, {
      type: 'fade',
      rewind: true,
      pagination: false,
      arrows: false
    });

    // custom prev/next buttons
    var prev = document.querySelector('.pdp-gallery__arrow--prev');
    var next = document.querySelector('.pdp-gallery__arrow--next');
    if (prev) prev.addEventListener('click', function () { splide.go('<'); });
    if (next) next.addEventListener('click', function () { splide.go('>'); });

    // thumbnails
    var thumbs = document.querySelectorAll('.pdp-gallery__thumb');
    thumbs.forEach(function (thumb, idx) {
      thumb.addEventListener('click', function () { splide.go(idx); });
    });

    splide.on('move', function (newIndex) {
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === newIndex);
      });
    });

    splide.mount();
  }

  // ---- Recently Viewed ----
  var RV_KEY = 'pdp_recently_viewed_handles';
  var RV_MAX = 12;

  function getRecentlyViewed() {
    try {
      var raw = localStorage.getItem(RV_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  function setRecentlyViewed(arr) {
    try { localStorage.setItem(RV_KEY, JSON.stringify(arr)); } catch (e) {}
  }
  function pushRecentlyViewed(handle) {
    if (!handle) return;
    var arr = getRecentlyViewed().filter(function (h) { return h !== handle; });
    arr.unshift(handle);
    if (arr.length > RV_MAX) arr = arr.slice(0, RV_MAX);
    setRecentlyViewed(arr);
  }

  function renderRecentlyViewed() {
    var container = document.querySelector('[data-pdp-recently-viewed]');
    if (!container) return;
    var currentHandle = container.getAttribute('data-current-handle') || '';
    var handles = getRecentlyViewed().filter(function (h) { return h !== currentHandle; });

    if (handles.length < 3) {
      container.style.display = 'none';
      return;
    }

    var limit = parseInt(container.getAttribute('data-limit') || '8', 10);
    handles = handles.slice(0, limit);

    var scroller = container.querySelector('[data-pdp-recently-viewed-scroller]');
    if (!scroller) return;

    // Fetch product data via Section Rendering API (product.js for each handle)
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      scroller.innerHTML = '';
      products.filter(Boolean).forEach(function (p) {
        scroller.insertAdjacentHTML('beforeend', renderRVCard(p));
      });
      if (scroller.children.length < 3) container.style.display = 'none';
    });
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderRVCard(p) {
    var img = p.featured_image ? p.featured_image : '';
    var url = p.url || ('/products/' + p.handle);
    var title = escapeHtml(p.title);
    var price = (p.price / 100).toLocaleString('ja-JP');
    return [
      '<a class="pdp-card" href="' + url + '">',
      '  <div class="pdp-card__media">',
      img ? '<img src="' + img + '&width=480" alt="' + title + '" loading="lazy">' : '',
      '  </div>',
      '  <div class="pdp-card__body">',
      '    <h3 class="pdp-card__title">' + title + '</h3>',
      '    <p class="pdp-card__price">¥' + price + '</p>',
      '  </div>',
      '</a>'
    ].join('');
  }

  // ---- Dynamic Price (variant + Globo add-ons) ----
  function setupPriceSync() {
    var wrap = document.querySelector('[data-pdp-base-price]');
    if (!wrap) return;

    var basePrice = parseInt(wrap.getAttribute('data-pdp-base-price') || '0', 10);
    if (!basePrice) return;

    var headerEl = document.querySelector('[data-pdp-header-price]');
    var totalEl = document.querySelector('[data-pdp-total]');
    var couponOff = parseInt(wrap.getAttribute('data-pdp-coupon-off') || '0', 10);
    var headerCouponEl = document.querySelector('[data-pdp-header-coupon]');
    var totalCouponEl = document.querySelector('[data-pdp-total-coupon]');

    function format(yen) {
      return '¥' + yen.toLocaleString('ja-JP');
    }

    function extractAddon(text) {
      if (!text) return 0;
      // patterns: (+ ¥6,000), (＋¥6,000), (+ 6,000円), (+6000)
      var m = text.match(/[（(][＋+][\s ]*[¥￥]?\s*([\d,]+)/);
      if (m) return parseInt(m[1].replace(/,/g, ''), 10);
      return 0;
    }

    function recalc() {
      var addonTotal = 0;
      var form = wrap.querySelector('form');
      if (!form) return;

      // radios / checkboxes
      var checked = form.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked');
      checked.forEach(function (input) {
        // find the visible label text
        var label = null;
        if (input.id) label = document.querySelector('label[for="' + input.id + '"]');
        if (!label) label = input.closest('label');
        if (label) addonTotal += extractAddon(label.textContent);
      });

      // selects
      var selects = form.querySelectorAll('select');
      selects.forEach(function (sel) {
        var opt = sel.options[sel.selectedIndex];
        if (opt) addonTotal += extractAddon(opt.textContent);
      });

      var totalYen = Math.floor((basePrice + addonTotal * 100) / 100);
      var disp = format(totalYen);
      if (headerEl && headerEl.textContent !== disp) headerEl.textContent = disp;
      if (totalEl && totalEl.textContent !== disp) totalEl.textContent = disp;

      if (couponOff > 0) {
        var couponDisp = format(Math.max(totalYen - Math.floor(couponOff / 100), 0));
        if (headerCouponEl && headerCouponEl.textContent !== couponDisp) headerCouponEl.textContent = couponDisp;
        if (totalCouponEl && totalCouponEl.textContent !== couponDisp) totalCouponEl.textContent = couponDisp;
      }
    }

    // listen to form changes
    var form = wrap.querySelector('form');
    if (form) {
      form.addEventListener('change', function () {
        setTimeout(recalc, 80);
      });
    }
    // Globo updates DOM asynchronously after page load — observe and recalc on mutation
    var mo = new MutationObserver(function () { recalc(); });
    if (form) mo.observe(form, { subtree: true, childList: true, attributes: true, characterData: true });

    // Initial
    setTimeout(recalc, 400);
    setTimeout(recalc, 1200);
  }

  // ---- Swym Wishlist button forced styling (inline) ----
  var HEART_SVG = '<svg class="pdp-heart" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="width:22px;height:22px;flex:0 0 22px;color:#7C3AED;"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';

  // Swym がオーバーレイとして描画する領域。この中は一切触らない
  var SWYM_UI_CONTAINERS = [
    '#swym-plugin',
    '#swym-hosted-plugin',
    '.swym-ui-component',
    '.swym-modal-bg',
    '.swym-modal-content',
    '.swym-add-wishlist-selector',
    '.swym-collections-popup-parent',
    '.swym-collections-popup-overlay',
    '.swym-atw-notification-container',
    '.swym-notifications-container',
    '.swym-storefront-extention-render-container'
  ].join(', ');

  function styleSwymWishlist() {
    // broader selector: anything that looks like an "add to wishlist" inline button
    var allCandidates = document.querySelectorAll('[class*="swym-add-to-wishlist"], button[class*="swym-button"]');
    var cartCta = document.querySelector('.pdp-cta');

    // Filter to in-page (non-fixed, non-launcher) buttons only
    var inPageBtns = [];
    allCandidates.forEach(function (b) {
      if (b.classList.contains('swym-launcher-button')) return;
      if (b.closest('.swym-header-launcher, .swym-overlay, .swym-notepad, .swym-popup')) return;
      // Swym 自身のUI（リスト選択モーダル・通知・ウィッシュリスト画面）の中のボタンは対象外。
      // ここを削除するとリストへの追加を確定できなくなる
      if (b.closest(SWYM_UI_CONTAINERS)) return;
      var cs = window.getComputedStyle(b);
      if (cs.position === 'fixed') return;
      inPageBtns.push(b);
    });

    // Prefer the already-moved button (next to cartCta) as the canonical one,
    // and remove all others. This is what stops the "increment on re-render".
    var canonical = null;
    if (cartCta) {
      for (var ic = 0; ic < inPageBtns.length; ic++) {
        if (inPageBtns[ic].parentElement === cartCta.parentElement &&
            inPageBtns[ic].previousElementSibling === cartCta) {
          canonical = inPageBtns[ic];
          break;
        }
      }
    }
    if (!canonical && inPageBtns.length > 0) canonical = inPageBtns[0];

    // Remove duplicates
    inPageBtns.forEach(function (b) {
      if (b !== canonical) {
        try { b.remove(); } catch (e) {}
      }
    });

    if (!canonical) return;
    inPageBtns = [canonical];

    // Move the canonical button to be the immediate next sibling of cartCta,
    // so it shares the same parent and inherits identical width/padding.
    if (cartCta && canonical.previousElementSibling !== cartCta) {
      try { cartCta.parentElement.insertBefore(canonical, cartCta.nextSibling); } catch (e) {}
    }

    inPageBtns.forEach(function (btn) {

      // Force button styling (always, even after Swym re-applies)
      var styles = {
        'width': '100%',
        'min-width': '0',
        'max-width': '100%',
        'box-sizing': 'border-box',
        'height': '56px',
        'background': '#ffffff',
        'background-color': '#ffffff',
        'background-image': 'none',
        'color': '#7C3AED',
        'border': '2px solid #1A1A1A',
        'border-radius': '0',
        'font-size': '1rem',
        'font-weight': '700',
        'letter-spacing': '0.04em',
        'display': 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        'gap': '8px',
        'margin': '12px 0 0 0',
        'padding': '0 16px',
        'cursor': 'pointer',
        'font-family': 'inherit',
        'box-shadow': 'none',
        'text-transform': 'none',
        'opacity': '1',
        'text-align': 'center',
        'line-height': '1'
      };
      if (window.innerWidth >= 990) {
        styles.height = '60px';
        styles['font-size'] = '1.125rem';
      }
      Object.keys(styles).forEach(function (k) {
        btn.style.setProperty(k, styles[k], 'important');
      });

      // Tint or hide any existing icons inside, then prepend our own heart if missing
      var existingIcons = btn.querySelectorAll('svg:not(.pdp-heart), i, .swym-icon');
      existingIcons.forEach(function (i) {
        i.style.setProperty('color', '#7C3AED', 'important');
        i.style.setProperty('fill', '#7C3AED', 'important');
      });
      if (!btn.querySelector('.pdp-heart')) {
        btn.insertAdjacentHTML('afterbegin', HEART_SVG);
      }
    });
  }

  // ---- Globo variant radio cards (generic) ----
  // DISABLED 2026-05-21: Globo デフォルトUI を尊重するため、テーマ側からの
  // 上書きは一切行わない方針に変更。装飾は Globo admin で行う。
  // (関数本体は履歴のため残すが、Init から呼び出していない)
  /* eslint-disable */
  function styleVariantRadios_disabled() {
    var wrap = document.querySelector('.pdp-form-wrap');
    if (!wrap) return;

    var inputs = wrap.querySelectorAll('input[type="radio"], input[type="checkbox"]');
    inputs.forEach(function (input) {
      // skip the cart-form hidden variant id input
      if (input.type === 'hidden' || input.name === 'id') return;

      // locate the label that visually represents this option
      var label = null;
      if (input.id) label = document.querySelector('label[for="' + input.id + '"]');
      if (!label) label = input.closest('label');
      if (!label) {
        // sibling label fallback
        var n = input.nextElementSibling;
        if (n && n.tagName === 'LABEL') label = n;
      }
      if (!label) return;

      // Visually hide the native input but keep it focusable / clickable via the label
      input.style.setProperty('position', 'absolute', 'important');
      input.style.setProperty('opacity', '0', 'important');
      input.style.setProperty('width', '1px', 'important');
      input.style.setProperty('height', '1px', 'important');
      input.style.setProperty('pointer-events', 'none', 'important');

      // Card-style label
      var labelStyles = {
        'display': 'flex',
        'align-items': 'center',
        'justify-content': 'space-between',
        'min-height': '56px',
        'padding': '12px 16px',
        'background': input.checked ? '#F5F3FF' : '#FFFFFF',
        'border': input.checked ? '2px solid #7C3AED' : '1px solid #E5E7EB',
        'border-radius': '8px',
        'margin': '0 0 8px 0',
        'width': '100%',
        'box-sizing': 'border-box',
        'cursor': 'pointer',
        'font-size': window.innerWidth >= 990 ? '1rem' : '0.9375rem',
        'font-weight': input.checked ? '700' : '400',
        'color': '#1A1A1A',
        'line-height': '1.4',
        'transition': 'border-color .15s ease, background .15s ease',
        'text-align': 'left',
        'gap': '8px'
      };
      Object.keys(labelStyles).forEach(function (k) {
        label.style.setProperty(k, labelStyles[k], 'important');
      });

      // ensure the label's own list-item parent shows correctly
      var li = label.closest('li');
      if (li) {
        li.style.setProperty('list-style', 'none', 'important');
        li.style.setProperty('margin', '0', 'important');
        li.style.setProperty('padding', '0', 'important');
      }
    });

    // Tighten container/list paddings inside Globo
    wrap.querySelectorAll('.gpo-select ul, .gpo-select ol').forEach(function (ul) {
      ul.style.setProperty('list-style', 'none', 'important');
      ul.style.setProperty('padding', '0', 'important');
      ul.style.setProperty('margin', '0', 'important');
    });

    // Group label (e.g. 「ケースカラー」「CPUグリス」「水冷クーラー」) emphasize.
    // We don't know Globo's exact class, so target a broad set: known Globo classes
    // + generic semantic tags (h1-h6, strong, b, dt, legend) and any element whose
    // class hints "label/title/name". Skip those that live inside the option label
    // (the per-option radio label we already styled above).
    var headingSel = [
      '.gpo-label', '.gpo-label .label-content',
      '[class*="gpo-label"]', '[class*="option-name"]', '[class*="option-title"]',
      '[class*="group-label"]', '[class*="group-title"]',
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'strong', 'b', 'dt', 'legend'
    ].join(',');
    wrap.querySelectorAll(headingSel).forEach(function (el) {
      // skip elements that are inside an option label (radio card) — those are
      // styled as part of the card label and must not become huge
      if (el.closest('label[for]')) return;
      // skip our own heading inside the section (e.g. アコーディオン header)
      if (el.closest('.pdp-info__head')) return;
      // skip if the element is INSIDE a card label we just styled
      el.style.setProperty('font-size', window.innerWidth >= 990 ? '1.5rem' : '1.375rem', 'important');
      el.style.setProperty('font-weight', '700', 'important');
      el.style.setProperty('color', '#1A1A1A', 'important');
      el.style.setProperty('display', 'block', 'important');
      el.style.setProperty('margin-top', '24px', 'important');
      el.style.setProperty('margin-bottom', '12px', 'important');
      el.style.setProperty('line-height', '1.4', 'important');
    });

    // The duplicated single-line summary that appears just under the group label
    // (e.g. "ガラスケース ブラック" appearing before the actual radio list)
    // is hard to suppress reliably without knowing Globo's class — leave as-is.
  }

  // ---- Init ----
  document.addEventListener('DOMContentLoaded', function () {
    initGallery();
    setupPriceSync();

    // Swym injects asynchronously; style at multiple intervals + MutationObserver
    styleSwymWishlist();
    setTimeout(styleSwymWishlist, 500);
    setTimeout(styleSwymWishlist, 1500);
    setTimeout(styleSwymWishlist, 3000);
    var swymObserver = new MutationObserver(function () { styleSwymWishlist(); });
    swymObserver.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', styleSwymWishlist);

    // Globo variant cards — DISABLED 2026-05-21
    // (Globo デフォルト UI を尊重、テーマ側から一切上書きしない)

    var currentEl = document.querySelector('[data-pdp-current-handle]');
    if (currentEl) {
      pushRecentlyViewed(currentEl.getAttribute('data-pdp-current-handle'));
    }
    renderRecentlyViewed();
  });
})();
